<section class="vm-row" [id]="data?.id">
  <h2 *ngIf="data?.title">
    {{ data?.title }}
  </h2>
  <vm-markdown *ngIf="data?.copy" [data]="data?.copy"></vm-markdown>
  <form [formGroup]="form" autocomplete="off" (ngSubmit)="submitForm()">
    <div class="vm-row center" *ngIf="form.get('postcode') as postcodeField">
      <div class="vm-col-lg-6 vm-col-md-6 vm-col-sm-8 vm-col-xs-12">
        <vm-text-input
          [classList]="'form-control'"
          name="postcode"
          formControlName="postcode"
          type="text"
          [required]="true"
          iconStyle="fal fa-location location_icon"
          iconColor="var(--tertiary-color)"
          (iconClick)="getPostCode()"
          [isError]="showError || (postcodeField?.errors && postcodeField?.touched)"
          [errorMessage]="data?.postcodeError"
          [label]="data?.postcodeLabel">
        </vm-text-input>
      </div>
    </div>
    <div class="vm-row center" *ngIf="form.get('lastName') as lastNameField">
      <div class="vm-col-lg-6 vm-col-md-6 vm-col-sm-8 vm-col-xs-12">
        <vm-text-input
          [classList]="'form-control'"
          formControlName="lastName"
          name="lastName"
          type="text"
          [required]="true"
          [isError]="showError || (lastNameField.invalid && (lastNameField.dirty || lastNameField.touched))"
          [errorMessage]="data?.lastNameError"
          [label]="data?.lastNameLabel">
        </vm-text-input>
      </div>
    </div>
    <div class="vm-row center" *ngIf="showHouseNumber && data?.multiAddressError">
      <div class="vm-col-lg-6 vm-col-md-6 vm-col-sm-8 vm-col-xs-12 house-number">
        <vm-notification [type]="type" class="vm-row">
          <vm-markdown [data]="data?.multiAddressError"></vm-markdown>
        </vm-notification>
      </div>
    </div>
    <div class="vm-row center" *ngIf="showHouseNumber && form.get('house') as houseNumField">
      <div class="vm-col-lg-6 vm-col-md-6 vm-col-sm-8 vm-col-xs-12 house-number">
        <vm-text-input
          [classList]="'form-control'"
          formControlName="house"
          name="house"
          type="text"
          [isError]="showError || (!houseNumField.value && (houseNumField.dirty || houseNumField.touched))"
          [errorMessage]="data?.houseNumError"
          [label]="data?.houseNumLabel">
        </vm-text-input>
      </div>
    </div>
    <div class="vm-row center">
      <div class="vm-col-lg-6 vm-col-md-6 vm-col-sm-8 vm-col-xs-12 submit">
        <vm-button
          id="postcodeLastNameNextStepBtn"
          class="identify-postcode-last-name-link"
          [type]="buttonType.SUBMIT"
          [level]="buttonLevel.TERTIARY">
          {{ data?.submitLabel }}</vm-button
        >
      </div>
    </div>
  </form>
</section>
